import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

export function parseCurrencyToCents(raw: string): number | null {
  const cleaned = raw.trim().replace(/[^\d,.]/g, '');
  if (!cleaned) return null;

  const hasComma = cleaned.includes(',');
  const dotCount = (cleaned.match(/\./g) ?? []).length;
  const normalized = hasComma
    ? cleaned.replace(/\./g, '').replace(',', '.')
    : dotCount > 1 || /^\d+\.\d{3}$/.test(cleaned)
      ? cleaned.replace(/\./g, '')
      : cleaned;

  const [reais = '0', cents = ''] = normalized.split('.');
  if (!/^\d+$/.test(reais) || (cents && !/^\d{1,2}$/.test(cents))) {
    return null;
  }

  return Number(reais) * 100 + Number((cents + '00').slice(0, 2));
}

export function parseCurrencyAmount(raw: string): number | null {
  const cents = parseCurrencyToCents(raw);
  return cents === null ? null : cents / 100;
}

export function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Bom dia';
  if (hour < 18) return 'Boa tarde';
  return 'Boa noite';
}

import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export function formatDate(date: string | Date): string {
  const parsed = new Date(date);

  return Number.isNaN(parsed.getTime())
    ? "Data não informada"
    : format(parsed, "dd/MM/yyyy", { locale: ptBR });
}
